import type { PainelDadosOutputType } from '../../../shared/dto';
import { callApi } from './call-api';

export const painelApi = {
  obter: (_args: void) => callApi<PainelDadosOutputType>({ path: '/painel' }),
};
